<div class="indicator-row justify-content-between">
  @if (isLoading) {
  <mat-progress-spinner diameter="12" mode="indeterminate"></mat-progress-spinner>
  } @else if (release) {
  <span class="indicator-label">Releases:</span>
  <a class="indicator-link" [routerLink]="['/', companyId, 'version', 'changelog']">changelog</a>
  <a class="indicator-link" [routerLink]="['/', companyId, 'version', release.version]">last: {{ release.version }}</a>
  }
</div>

<ng-template #notifiticationVersion>
  <div
    class="d-flex flex-column align-items-center"
    style="width: 300px; height: 250px"
  >
    <mat-progress-bar
      class="d-flex justify-content-center align-items-center"
      mode="determinate"
      [value]="closeProgress"
      [bufferValue]="100"
      [color]="'primary'"
    ></mat-progress-bar>
    <div class="ms-auto">autoclose in {{ (100 - closeProgress) / 10 }}sec</div>
    <div class="my-auto grow-1">
      <div class="d-flex flex-row justify-content-center align-items-center">
        <mat-icon>update</mat-icon>
        <b> New version available: {{ release?.version }} </b>
      </div>
      <div class="text-center">{{ release?.short_summary }}</div>
    </div>
    <div
      class="d-flex flex-row justify-content-center align-items-center mt-auto w-100"
    >
      <button class="me-auto" matButton="outlined" (click)="dismiss()">
        dismiss
      </button>
      <button
        mat-raised-button
        color="primary"
        [routerLink]="['/', companyId, 'version', release?.version]"
      >
        View
      </button>
    </div>
  </div>
</ng-template>
